/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionAclContextDetails {
    getFixupPrototypeFunction() { return DashboardDefinitionAclContextDetails.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionAclContextDetails>): DashboardDefinitionAclContextDetails {
        let obj = Object.assign(new DashboardDefinitionAclContextDetails(), model);
        DashboardDefinitionAclContextDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionAclContextDetails>): DashboardDefinitionAclContextDetails {
        if (!model) return null;
        return DashboardDefinitionAclContextDetails.newInstance(<DashboardDefinitionAclContextDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionAclContextDetails) {
        if (!obj) return;

        models.DashboardDefinitionAclContextDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionAclContextDetails): boolean {
        Object.setPrototypeOf(obj, DashboardDefinitionAclContextDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    id: string;

    name: string;

}
